import $ from "jquery";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { getImageByContentId } from "#scripts/images";
import { createGuid } from "#scripts/general_functions";
import language from "#scripts/translation";

export const getEvents = (load, from, mode, callback) => {
	const categoriesapiId = window.serverdata.configMeta.aim.calendar.localid;
	const calendarNameId = window.serverdata.configMeta.aim.calendar.group;
	const munic = window.serverdata.configMeta.aim.calendar.municipalities || "";
	fetch(
		`https://sspkalender.prokom.no/api/tidspunkt?Categories=${categoriesapiId}&SearchText=&DateFrom=&DateTo=&Municipalities=${munic}&Kunde=${calendarNameId}&Id=&ItemDate=&WeekDays=&List=${mode}&Count=&Distributor=`,
	)
		.then((data) => data.json())
		.then((data) => {
			callback(data);
		});
};

export const eventsModule = (_maxItems, moduleTitle, mode, moduleLinks) => {
	const more = "";
	let content = "";
	const maxItems = Number.parseInt(_maxItems);

	getEvents(maxItems, 0, mode, (data) => {
		const tmpMode = mode.split("-");
		const modePart = tmpMode[0];

		let events = [];
		let nofItems = data.FullListOfEvents?.length || (data.MonthWithEvents !== null ? data.MonthWithEvents[0]?.DaysWithEvents.length : 0);
		if (nofItems === undefined) {
			nofItems = 0;
		}
		if (nofItems >= 0) {
			if (modePart === "compact" && data.FullListOfEvents?.length > 0) {
				data.FullListOfEvents.forEach((item, index) => {
					if (index > maxItems - 1) {
						return;
					}
					dayjs.extend(updateLocale);
					dayjs.updateLocale(
						"nb",
						{
							weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
							monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
						},
						"nn",
						{
							weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
							monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
						},
					);

					const from = dayjs(item.FraDato);
					const image = item.KalenderObjekt?.MedieFiler[0]?.ThumbnailUrl;
					let img = "";
					// const width = 'col-sm-9';

					if (image !== undefined && image.length > 0) {
						const imgId = createGuid();
						img = `
                <div class="image__container">
                    <img src="${image}" alt="" class="article__introimage" id="${imgId}">
                </div>`;
						// $(`#${imgId}`).attr("src", image);
					} else {
						img = `
								<div class="calendargrid__image-container">
                		<div class="calendar__item__image" data-src=""><img src="" style="min-height: 200px;"></div>
                </div>`;
					}

					const repeating = item.OverFlereDager || item.Repeterende;
					events.push(`
                <div class="event__item">
                  <a href="/event_custom/${item.Id}" class="event__item__link">
                    <div class="event__item_grid">
                      <div class="event__info-container">
                      ${img}
                        <div class="event__item__title">
                          ${item.Name}
                        </div>
                        <div>
                        ${
													item.KalenderObjekt.Sted[0].Adresse !== null
														? `
                          <p class="event__item__place">
                            <span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-place"></span>
                            ${item.KalenderObjekt.Sted[0].Name !== null ? `${item.KalenderObjekt.Sted[0].Name}, ` : ""}${item.KalenderObjekt.Sted[0].Adresse}
                          </p>`
														: ""
												}
                          </p>
                          <p class="event__item__time-stamp">
                            <span class="material-icons-outlined notranslate calendar__item__icon calendar__item__icon-date${repeating ? "-repeat" : ""}"></span>
                            ${from.format("dddd DD. MMMM  kl. HH:mm")} ${repeating ? language("ACTIVITY_MORE_DATES") : ""}
                        </div>
                      </div>
                    </div>
                  </a>
                </div>`);
				});
			} else if (modePart !== "compact" && data.MonthWithEvents?.length > 0) {
				data.MonthWithEvents[0].DaysWithEvents.forEach((item, index) => {
					if (index > maxItems - 1) {
						return;
					}
					const from = dayjs(item.FraDato);
					for (const event of item.Events) {
						events.push(`
                  <div class="event__item">
                    <div class="row row-eq-height event__item_grid">
                      <div class="event__info-container">
                        <div>
                          <a href="/event/${event.Id}" class="event__item__link">${event.Name}</a>
                        </div>
                        <div>
                          <p class="event__item__place">
                            <span class="material-icons-outlined notranslate event__item__icon event__item__icon-place"></span>
                            ${event.Lokasjon.Name !== null ? `${event.Lokasjon.Name}, ` : ""}$${event.Lokasjon.Adresse}
                          </p>
                          <p class="event__item__time-stamp">
                            <span class="material-icons-outlined notranslate event__item__icon event__item__icon-time"></span>
                            ${from.format("dddd DD. MMMM kl. HH:mm")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>`);
					}
				});
			}

			events = events.join("");

			const newLinkButton = "";
			const links = moduleLinks !== "" ? `<div class="events__grid  events__grid__more">${setLinkList(moduleLinks)}</div>` : "";

			content = `
            <div class="events events__pre-container"></div>
            <div class="events">
                <div class="events__container">
                        <div class="events__head__row"><h2 class="events__title">${moduleTitle !== undefined ? moduleTitle : language("START_CALENDAR")}</h2></div>
                        <div class="events__grid">
                        ${events}
                        </div>
                        ${links}
                        <div class="text-right">
                        <div class="events__more__container">
                            ${more}
                            ${newLinkButton}
                        </div>
                        </div>
                </div>
            </div>
            <div class="events events__post-container"></div>`;

			$("#eventslist__frontpage").html(content);
		}
	});

	return '<div id="eventslist__frontpage"></div>';
};

export const eventspage = () => {
	const list = setEventsList();
	return `
        <div class="eventslist__page" id="eventslistcontainer">
            ${list}
        </div>`;
};

export const setEventsList = (_from, _loadNum) => {
	// const breadcrumbHtml = breadcrumb();
	const loadNum = _loadNum || 10;
	const from = _from || 0;

	getEvents(loadNum, from, (result) => {
		const availableevents = result.totalCount;
		const to = loadNum + from;
		let eventList = [];

		$.each(result.listOfContent, (a, b) => {
			const date = new Date(b.firstCreated);
			const pDate = `${`0${date.getDate()}`.slice(-2)}-${`0${date.getMonth() + 1}`.slice(-2)}-${date.getFullYear()}`;
			const meta = JSON.parse(decodeURIComponent(b.metaObject));
			let img = "";
			const width = "col-sm-9";

			if (meta.imageContentId !== undefined && meta.imageContentId.length > 0) {
				const imgId = createGuid();
				img = `
                    <div class="col-sm-3 image__container">
                        <img src="" alt="" class="article__introimage" id="${imgId}" >
                    </div>`;

				getImageByContentId(meta.imageContentId, (img) => {
					if (img.url !== undefined && img.url.length > 0) {
						$(`#${imgId}`).attr("src", img.url);
					}
				});
			}

			eventList.push(`
                <div class="calendarlist__item">
                    <div class="row">
                        <a href = "/article/${b.contentId}" class = "calendarlist__link" >
                            ${img}
                            <div class="${width}">
                                <div class="calendarlist__content">
                                    <h3 class="calendarlist__header">
                                        ${b.title}
                                    </h3>
                                    <p class="calendarlist__intro">${b.intro}</p>
                                    <div class="calendarlist__date">${pDate}</div>
                                </div>
                            </div> 
                        </a>
                    </div>
                </div>`);
		});

		// $("#currentPageBreadcrumb").text(document.title);
		eventList = eventList.join("");

		$(".calendarlist__list").append(eventList);
		const eventListHeader = `
            <div class="row">
                <div class="col mt-5">
                    <p>
                        Viser nyhet ${from + 1} til ${availableevents > to ? to : availableevents} av ${availableevents}
                    </p>
                </div>
            </div>`;

		$(".calendarlist__info").html(eventListHeader);
		if (availableevents > loadNum) {
			const pages = Math.ceil(availableevents / loadNum);
			let pageslinks = [];
			let i = 0;

			for (i = 0; i < pages; i++) {
				pageslinks.push(`
                    <li class="page-item ${i * loadNum === from ? "disabled" : ""}"><a class="page-link calendar__page__links " href="#" data-from="${
											i * loadNum
										}" >${i + 1}</a></li>`);
			}

			pageslinks = pageslinks.join("");
			const eventListFooter = `
                <div class="row">
                    <div class="col mt-5">
                        <nav aria-label="Bla i sider">
                          <ul class="pagination  pagination-lg">
                            ${pageslinks}
                          </ul>
                        </nav>
                    </div>
                </div>`;

			$(".calendarlist__footer").html(eventListFooter);
		}
	});

	$("body").off("click", ".calendar__page__links");
	$("body").on("click", ".calendar__page__links", function (e) {
		e.preventDefault();
		const num = $(this).data("from");
		setEventsList(Number.parseInt(num));
		// $(window).scrollTo(0);
	});

	const listcontainer = `
        <div class="container">
            <div class="row">
                <div class="calendarlist col">
                    <h1 class="page__header">Nyheter</h1>
                    <div class="calendarlist__info"></div>
                    <div class="calendarlist__list"></div>
                    <div class="calendarlist__footer"></div>
                </div>
            </div>
        </div>`;

	$("#calendarlistcontainer").html(listcontainer);
	return listcontainer;
};

export const setLinkList = (links) => {
	const linksArray = links.split(";").map((x) => x.replace("}", "").split("{"));
	const linksRow = [];
	for (const item of linksArray) {
		let icon = "arrow_forward";
		let target = "";
		if (item[1]?.includes("://")) {
			icon = "open_in_new";
			target = "_blank";
		}
		const link = `
            <div class="calendar__grid__links">
                <a class="buttonrow__button" href="${item[1]}" target="${target}" rel="noopener noreferrer">
                    ${item[0]}
                    <span class="material-icons-outlined notranslate buttonrow__button__icon">${icon}</span>
                </a>
            </div>`;
		linksRow.push(link);
	}
	if (linksRow.length === 1) {
		linksRow.push("<div></div>");
	}
	return linksRow.join("");
};
